import { useUserContext } from "../providers/UserAuthProvider/UserProvider"
import { usePostRequest } from "./useRequest"

export type SurveyType =
  | "NPS_SURVEY"
  | "EXPERIENCE_ATTENDANCE_SURVEY"
  | "POST_EXPERIENCE_SURVEY"

type RecordAttendnanceRequest = {
  type: SurveyType
  response: {
    experience_id: string
    attended: boolean
  }
}

type RecordPostExperienceSurveyeRequest = {
  type: SurveyType
  response: {
    experience_id: string
    rating: number
    feedback: string
  }
}

export const useRecordAttendance = () => {
  const { accessToken } = useUserContext()
  const { postRequestAsync, ...rest } = usePostRequest<
    unknown,
    RecordAttendnanceRequest
  >({
    path: `v1/users/me/surveys`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return {
    recordAttendance: async (experience_id: string, attended: boolean) => {
      try {
        const result = await postRequestAsync({
          body: {
            type: "EXPERIENCE_ATTENDANCE_SURVEY",
            response: {
              experience_id,
              attended,
            },
          },
        })
        return result
      } catch (err) {
        throw err
      }
    },
    ...rest,
  }
}

export const useRecordPostExperienceSurvey = () => {
  const { accessToken } = useUserContext()
  const { postRequestAsync, ...rest } = usePostRequest<
    unknown,
    RecordPostExperienceSurveyeRequest
  >({
    path: `v1/users/me/surveys`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return {
    recordPostExperienceSurvey: async (
      experience_id: string,
      rating: number,
      feedback: string,
    ) => {
      try {
        const result = await postRequestAsync({
          body: {
            type: "POST_EXPERIENCE_SURVEY",
            response: {
              experience_id,
              rating,
              feedback,
            },
          },
        })
        return result
      } catch (err) {
        throw err
      }
    },
    ...rest,
  }
}
